export default __webpack_public_path__ + "static/media/Dalton.84ed3d4c.png";